'use client';

import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
import indicatorStyles from '@/app/lcv/components/sections/spartan/shared/tabs/indicator.module.css';
import type { SpartanTabsGlowIndicatorTone } from '@/app/lcv/components/sections/spartan/shared/tabs/types';
interface SpartanTabsIndicatorDarkVectorProps {
  indicatorTone?: SpartanTabsGlowIndicatorTone;
}

/**
 * Figma blob export (308×104 including blur padding).
 * viewBox crops to the 198×40 pill so the shape lines up with the face layer.
 */
export const SpartanTabsIndicatorDarkVector = t0 => {
  const $ = _c(26);
  const {
    indicatorTone: t1
  } = t0;
  const indicatorTone = t1 === undefined ? "orange" : t1;
  const t2 = useId();
  let t3;
  if ($[0] !== t2) {
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = /:/g;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    t3 = t2.replace(t4, "");
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const id = t3;
  const filterId = `spartan-tabs-indicator-vector-filter-${id}`;
  const gradientId = `spartan-tabs-indicator-vector-gradient-${id}`;
  const t4 = `url(#${filterId})`;
  const t5 = `url(#${gradientId})`;
  let t6;
  if ($[3] !== t5) {
    t6 = <path d="M144.8 85.5891C117.555 89.9555 71.0103 87.4084 51.1437 85.5891C-30.5928 75.128 53.3329 56.5474 72.0642 55.183C90.7955 53.8185 117.19 41.0832 129.109 31.5318C148.408 16.0675 229.942 16 257.188 16C284.433 16 299.394 25.1641 288.325 34.2607C277.257 43.3574 224.469 47.4508 267.04 77.0148C201.48 98.8467 178.857 80.1311 144.8 85.5891Z" fill={t5} />;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t4 || $[6] !== t6) {
    t7 = <g filter={t4}>{t6}</g>;
    $[5] = t4;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <feGaussianBlur in="SourceGraphic" stdDeviation="8" result="effect1_foregroundBlur" />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== filterId) {
    t9 = <filter id={filterId} x="0" y="0" width="308" height="104" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">{t8}</filter>;
    $[9] = filterId;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = indicatorTone === "orange" ? "0.404295" : undefined;
  let t11;
  if ($[11] !== t10) {
    t11 = <stop className={indicatorStyles.vectorStart} offset={t10} />;
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <stop className={indicatorStyles.vectorEnd} offset="1" />;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== gradientId || $[15] !== t11) {
    t13 = <linearGradient id={gradientId} x1="212.032" y1="15.9953" x2="157.847" y2="88.8475" gradientUnits="userSpaceOnUse">{t11}{t12}</linearGradient>;
    $[14] = gradientId;
    $[15] = t11;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t13 || $[18] !== t9) {
    t14 = <defs>{t9}{t13}</defs>;
    $[17] = t13;
    $[18] = t9;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t14 || $[21] !== t7) {
    t15 = <svg viewBox="77 36 198 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="size-full" overflow="visible" preserveAspectRatio="none" aria-hidden="true">{t7}{t14}</svg>;
    $[20] = t14;
    $[21] = t7;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== indicatorTone || $[24] !== t15) {
    t16 = <span aria-hidden="true" data-indicator-vector-tone={indicatorTone} className={indicatorStyles.vector}>{t15}</span>;
    $[23] = indicatorTone;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  return t16;
};